import { Injectable } from "@angular/core";
import { GetAvailableKpiMonthsGQL, GetKpisGQL, KpiGetInput, KpiMonth, KpiResultsFragment } from "@ankaadia/graphql";
import { map, Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class KpisService {
  constructor(
    private readonly getKpisGql: GetKpisGQL,
    private readonly getAvailableKpiMonthsGql: GetAvailableKpiMonthsGQL
  ) {}

  getKpis(input: KpiGetInput): Observable<KpiResultsFragment> {
    return this.getKpisGql
      .fetch({ input: input }, { fetchPolicy: "network-only" })
      .pipe(map((result) => result.data.getKpis));
  }

  getAvailableMonths(): Observable<KpiMonth[]> {
    return this.getAvailableKpiMonthsGql
      .fetch({}, { fetchPolicy: "network-only" })
      .pipe(map((result) => result.data.getAvailableKpiMonths.months));
  }
}
